import axios from "axios";
import {Configuration, JwtResponse, LoginVM, UserJwtControllerApi} from "@/marketing-api-client";

export class UserJwtService extends Error {
    basePath: string;
    authApi: UserJwtControllerApi;

    constructor(basePath: string) {
        super();
        this.basePath = basePath;

        const axiosInstance = axios.create({
            baseURL: basePath,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Create API instance for SSO
        const config = new Configuration({
            basePath: basePath
        });

        this.authApi = new UserJwtControllerApi(config, basePath, axiosInstance);
    }

    async authenticateUser(loginVM: LoginVM): Promise<JwtResponse> {
        const response = await this.authApi.authenticateUser(loginVM);
        const pageResponse: JwtResponse = response.data;
        return pageResponse;
    }

}
